import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';
import catchUpOff from '@r1-frontend/api-domru/api-profile/v1/catch-up/catch-up/catch-up-off';
import catchUpOn from '@r1-frontend/api-domru/api-profile/v1/catch-up/catch-up/catch-up-on';
import { doRequest } from '@r1-frontend/do-request';
import { EVENTS } from '@r1-frontend/shared/constants/analytics';
import { BaseButton, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import PopupResult from '@r1-frontend/ui-react/components/popups/popupResult';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import PopupNoAuth from '~/src/components/Popups/NoAuth';
import { ddmmyyyy } from '~/src/helpers/date';
import NoSSR from '~/src/helpers/noSSR';
import { getCatchUpStatusState } from '~/src/store/actions/catchup';
import { openChat } from '~/src/store/actions/chat';

import {
    Background,
    BackgroundSource,
    Button,
    Content,
    Cost,
    CostLink,
    Currency,
    Form,
    Note,
    Phone,
    Plug,
    Price,
    Section,
    Support,
    Title,
} from './styled';

class SectionOrder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            popupNoAuthIsOpen: false,
            price: props.price,
            current_price: null,
            activate: false,
            availiable: false,
            date_to: null,
            unset_from: null,
            result: null,
        };
    }

    componentDidMount() {
        this.updateCatchUpState();
    }

    componentDidUpdate({ auth }) {
        if (JSON.stringify(auth.clientPersonal) !== JSON.stringify(this.props.auth.clientPersonal)) {
            this.updateCatchUpState();
        }
    }

    updateCatchUpState = async() => {
        const {
            auth: { isAuth, clientPersonal },
        } = this.props;

        if (!isAuth || !clientPersonal.agreementId) {
            return;
        }
        await this.props.getCatchUpStatusState(clientPersonal.agreementId);
        const info = this.props.catchup.info['0'];
        if (info) {
            const {
                activate,
                availiable,
                current_price,
                date_to,
                included_agr,
                price,
                unset_from,
            } = this.props.catchup.info['0'];

            this.setState({
                activate: Boolean(Number(activate)),
                availiable: Boolean(Number(availiable)),
                current_price,
                date_to,
                included_agr: Boolean(Number(included_agr)),
                price,
                unset_from,
            });
        }
    }

    sendAnalytics = (params) => dataLayerPush({
        event: EVENTS.UAevent,
        category: 'service catchup',
        label: '',
        ...params,
    });

    togglePopup = popupNoAuthIsOpen => {
        this.setState({ popupNoAuthIsOpen });
    };

    onPlug = async(e) => {
        if (e.cancelable) {
            e.preventDefault();
        }
        const { auth: { isAuth, clientPersonal } } = this.props;

        this.sendAnalytics({ action: 'btn click on connect' });

        if (isAuth) {
            const resp = await doRequest.apiProfile(
                catchUpOn({ agreement_id: clientPersonal.agreementId }),
            );
            if (resp.isSuccess) {
                this.updateCatchUpState(); // Обновляем статус формы

                this.setState({
                    result: {
                        title: 'Услуга «Управляй просмотром» успешно подключена',
                        type: 'success',
                        text: '',
                    },
                });

                this.sendAnalytics({ action: 'success application client' });
            } else {
                const { error } = resp;
                const result = {
                    title: 'Возникла ошибка при подключении',
                    type: 'error',
                    text: <React.Fragment>Написать в&nbsp;
                        <CostLink onClick={this.onClickChat}>чат техподдержки</CostLink>
                    </React.Fragment>,
                };

                if (error.code === 'INSUFFICIENT_CREDIT_BALANCE') {
                    result.title = error.message || 'Недостаточно средств для подключения услуги';
                    result.text = 'Пожалуйста, пополните счёт.';
                } else if (error.code === 'SERVICE_ALREADY_ACTIVATE') {
                    result.title = error.message || 'Услуга уже активирована на договоре';
                }

                this.setState({ result });

                this.sendAnalytics({ action: 'error application client' });
            }
        } else {
            this.sendAnalytics({ action: 'new user request' });
            this.togglePopup(true);
        }
    };

    onUnPlug = async(e) => {
        if (e.cancelable) {
            e.preventDefault();
        }
        const { auth: { clientPersonal } } = this.props;
        const resp = await doRequest.apiProfile(
            catchUpOff({ agreement_id: clientPersonal.agreementId }),
        );
        if (resp.isSuccess) {
            this.updateCatchUpState(); // Обновляем статус формы
            this.sendAnalytics({ action: 'turn off service' });

            this.setState({
                result: {
                    title: 'Услуга «Управляй просмотром» успешно отключена',
                    type: 'success',
                    text: '',
                },
            });
        } else {
            const { error } = resp;
            const result = {
                title: 'Возникла ошибка при отключении услуги',
                type: 'error',
                text: <React.Fragment>Написать в&nbsp;
                    <CostLink onClick={this.onClickChat}>чат техподдержки</CostLink>
                </React.Fragment>,
            };

            if (error.code === 'INITIAL_PERIOD_STILL_ACTIVE') {
                result.text = '';

                const period = error.message.split('чем через');
                if (period[1]) {
                    result.title = `Отключить услугу можно через${period[1].replace('.', '')}`;
                }
            }

            this.setState({ result });
        }
    };

    onCloseResult = () => {
        this.setState({
            result: null,
        });
    };

    onClickMovixPro = () => {
        this.sendAnalytics({
            action: 'btn click on movix pro',
        });
    };

    onClickChat = () => {
        this.sendAnalytics({ action: 'btn click on chat' });
        this.props.openChat();
    };

    onClickRequest = () => {
        this.sendAnalytics({
            action: 'new user request',
        });
    };

    render() {
        const { auth: { isAuth }, city: { phone }, activeSlide, prevSlide, ...props } = this.props;
        const { popupNoAuthIsOpen, result, price, current_price, activate, availiable, included_agr, date_to, unset_from } = this.state;
        const hasResult = Boolean(result);
        const dateTo = ddmmyyyy(new Date(date_to ? Number(date_to + '000') : 0));
        const unsetFrom = ddmmyyyy(new Date(unset_from ? Number(unset_from + '000') : 0));
        const isActive = (activeSlide.link === 'order');
        const from = (isActive) ? prevSlide.link : null;
        const to = (!isActive) ? activeSlide.link : null;

        return (
            <Section isActive={isActive} from={from} to={to} {...props}>
                <Content>
                    <Form>
                        {isAuth && <React.Fragment>
                            {Boolean(activate) && Boolean(availiable) && <React.Fragment>
                                <Title as='h2'>Управление услугой<br/>«Управляй просмотром»</Title>
                                <Plug>
                                    <Cost>
                                        {date_to !== '' && <p>Текущая услуга доступна до&nbsp;{dateTo}</p>}
                                        <p>Абонентская плата: {current_price} ₽/мес.</p>
                                        <br/>
                                        {unset_from
                                            ? <p>Отключение услуги возможно после {unsetFrom}</p>
                                            : <Button
                                                type={btnTypes.ACCENT}
                                                onClick={this.onUnPlug}
                                                text='Отключить'
                                              />
                                        }
                                        {
                                             activate && included_agr && <p>Входит в тариф</p>
                                        }
                                    </Cost>
                                </Plug>
                            </React.Fragment>}

                            {!availiable && <React.Fragment>
                                <Title as='h2'>Управление услугой<br/>«Управляй просмотром»</Title>
                                <Plug>
                                    <Cost>
                                        Услуга недоступна для подключения. Пожалуйста, обратитесь в&nbsp;
                                        <CostLink onClick={this.onClickChat}>службу&nbsp;поддержки.</CostLink>
                                    </Cost>
                                </Plug>
                            </React.Fragment>}
                        </React.Fragment>}

                        {(!isAuth || (Boolean(availiable) && !activate)) && <React.Fragment>
                            <Title as='h2'>Подключение услуги<br/>«Управляй просмотром»</Title>
                            <Plug>
                                <Cost>
                                    <div>Ежемесячный платеж</div>
                                    <Price>{price} <Currency>Р/мес</Currency></Price>
                                </Cost>
                                <BaseButton type={btnTypes.ACCENT} onClick={this.onPlug} text='Подключить'/>
                            </Plug>
                            <Note>
                                <p>
                                    1 месяц в подарок при покупке приставки{' '}
                                    <a
                                        target='_blank'
                                        rel='nofollow noopener'
                                        href='/movix-new'
                                        onClick={this.onClickMovixPro}
                                    >
                                        Movix Pro
                                    </a>.
                                </p>
                            </Note>
                        </React.Fragment>}

                        {hasResult && <NoSSR>
                            <PopupResult
                                isOpen={hasResult}
                                title={result.title}
                                type={result.type}
                                onClose={() => this.onCloseResult(result.type)}
                            >
                                {result.text}
                            </PopupResult>
                        </NoSSR>}

                        {!isAuth && <NoSSR>
                            <PopupNoAuth
                                close={() => this.togglePopup(false)}
                                open={popupNoAuthIsOpen}
                                onClickRequest={this.onClickRequest}
                            />
                        </NoSSR>}
                    </Form>
                    <Support>
                        Остались вопросы? Позвоните <Phone as='a' href={`tel:+${phone.replace(/\D/g, '')}`}>{phone}</Phone>
                    </Support>
                </Content>
                <Background>
                    <source srcSet='/static/images/catchup/order-bg.webp' type='image/webp'/>
                    <BackgroundSource draggable={false} src='/static/images/catchup/order-bg.png' alt='television'/>
                </Background>
            </Section>
        );
    }
}

const mapStateToProps = ({ city, auth, catchup }) => ({
    city: city.currentCity,
    auth,
    catchup,
});

const mapDispatchToProps = (dispatch) => ({
    openChat: () => dispatch(openChat()),
    getCatchUpStatusState: (agreement_id) => dispatch(getCatchUpStatusState(agreement_id)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SectionOrder);
